import React from "react";
import { useNavigate } from "react-router-dom";
import { createRoomImage, getRoomList } from "adminApi/RoomImagesApi/RoomImage";
import { validateForm } from "utils/validation";
import { RoomImagesRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/RoomImageField.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import AddRoomImagesForm from "./Components/AddRoomImagesForm";
import useFetchAllData from "Hooks/useFetchAllData";
import useSequentialImageUpload from "Hooks/useSequentialImageUpload";

const AddRoomImages = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = formdata.reduce(
        (acc, field) => ({ ...acc, [field.name]: "" }),
        {}
    );

    const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(
        initialValues,
        RoomImagesRules
    );

    const { data: roomList, loading: loadingRoomList } = useFetchAllData(getRoomList);

    const { uploadImages, uploading } = useSequentialImageUpload(createRoomImage);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const { room_image, room_imagePreview, ...rest } = formValues;
            await uploadImages({
                files: room_image,
                fileFieldName: "room_image",
                payload: rest,
                successMessage: "Room images uploaded successfully",
            });
            return {
                data: { success: true, data: { message: "Room images uploaded" } },
            };
        },
        (vals) => {
            // Copy before mutating to avoid modifying original state
            const v = { ...vals };
            delete v.room_imagePreview;
            const err = validateForm(v, RoomImagesRules);
            if (err) setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Room Images added successfully"
    );

    return (
        <>
            {(loadingSubmit || uploading || loadingRoomList) && <Spinner isSpinner={true} />}
            <AddRoomImagesForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleFileChange={handleFileChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit || uploading}
                imagePreview={values.room_imagePreview}
                roomList={roomList || []}
            />
        </>
    );
};

export default AddRoomImages;
